import React from "react";
const SvgVideo = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M21.4 15.228a.699.699 0 01-.405.643.702.702 0 01-.754-.088l-3.903-3.142v-1.886l3.903-3.142a.7.7 0 01.754-.088.698.698 0 01.405.643v7.06zm-6.062.417c0 .965-.786 1.75-1.75 1.75H4.75c-.965 0-1.75-.785-1.75-1.75V7.75C3 6.786 3.785 6 4.75 6h8.838c.964 0 1.75.786 1.75 1.75v7.895zm6.089-9.021a1.698 1.698 0 00-1.813.21l-3.276 2.637V7.75A2.754 2.754 0 0013.588 5H4.75A2.754 2.754 0 002 7.75v7.895a2.754 2.754 0 002.75 2.75h8.838a2.754 2.754 0 002.75-2.75v-1.72l3.276 2.636a1.7 1.7 0 001.813.211c.6-.287.973-.878.973-1.544v-7.06c0-.666-.373-1.257-.973-1.544z"
    />
  </svg>
);
export default SvgVideo;
